export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"hid":"description","name":"description","content":"O objetivo desta solução é permitir uma Fiscalização de Estacionamento, o mais automatizada possível,  pelos Agentes de Fiscalização de Estacionamento, que regra geral tudo o que têm de fazer é de tirar uma fotografia que o nosso software faz o resto!"},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://admin.mobiin.pt"},{"property":"og:title","content":"MOBI.IN"},{"property":"og:description","content":"O objetivo desta solução é permitir uma Fiscalização de Estacionamento, o mais automatizada possível,  pelos Agentes de Fiscalização de Estacionamento, que regra geral tudo o que têm de fazer é de tirar uma fotografia que o nosso software faz o resto!"},{"property":"og:image","content":"/icon.png"},{"property":"twitter:card","content":"summary_large_image"},{"property":"twitter:url","content":"https://admin.mobiin.pt"},{"property":"twitter:title","content":"MOBI.IN"},{"property":"twitter:description","content":"O objetivo desta solução é permitir uma Fiscalização de Estacionamento, o mais automatizada possível,  pelos Agentes de Fiscalização de Estacionamento, que regra geral tudo o que têm de fazer é de tirar uma fotografia que o nosso software faz o resto!"},{"property":"twitter:image","content":"/icon.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"stylesheet","href":"https://api.mapbox.com/mapbox-gl-js/v3.12.0/mapbox-gl.css"}],"style":[],"script":[],"noscript":[],"title":"MOBI.IN"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt","class":"isolate"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true